var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-box p-5" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-form" },
      [
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.sign_in($event)
              }
            }
          },
          [
            _c("div", { staticClass: "row form-group c-form__group" }, [
              _c(
                "label",
                { staticClass: "col-12 c-form__label", attrs: { for: "cId" } },
                [_vm._v("Panel ID")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("b-form-input", {
                    attrs: { name: "cId", id: "cId" },
                    model: {
                      value: _vm.c_id,
                      callback: function($$v) {
                        _vm.c_id = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "c_id"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group c-form__group" }, [
              _c(
                "label",
                {
                  staticClass: "col-12 c-form__label",
                  attrs: { for: "username" }
                },
                [_vm._v("Email")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("b-form-input", {
                    attrs: { name: "username", id: "username" },
                    model: {
                      value: _vm.username,
                      callback: function($$v) {
                        _vm.username =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "username"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group c-form__group" }, [
              _c(
                "label",
                {
                  staticClass: "col-12 c-form__label",
                  attrs: { for: "password" }
                },
                [_vm._v("Password")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("b-form-input", {
                    attrs: {
                      name: "password",
                      type: "password",
                      id: "password"
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group c-form__group" }, [
              _c(
                "label",
                {
                  staticClass: "col-12 c-form__label",
                  attrs: { for: "two_fa_code" }
                },
                [_vm._v("2FA Code")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("b-form-input", {
                    attrs: { id: "two_fa_code" },
                    model: {
                      value: _vm.two_fa_code,
                      callback: function($$v) {
                        _vm.two_fa_code = $$v
                      },
                      expression: "two_fa_code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(1)
            ]),
            _vm._v(" "),
            _vm.login_in_progress === false
              ? _c("button", { staticClass: "c-btn c-btn--success" }, [
                  _vm._v("\n                Sign in\n            ")
                ])
              : _c(
                  "button",
                  {
                    staticClass: "c-btn c-btn-default js--btn-loading-modal",
                    attrs: { disabled: "" }
                  },
                  [_vm._v("\n                Loading...\n            ")]
                ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "c-btn c-btn-default",
                attrs: {
                  to: {
                    name: "forgot_password.main",
                    params: { company_id: _vm.c_id }
                  }
                }
              },
              [_vm._v("\n                Forgot password?\n            ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("login-password-main-ccs-modal")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-box__header mb-5" }, [
      _c("div", { staticClass: "c-box__title text-center text-uppercase" }, [
        _vm._v("\n            Login to your account\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", { staticClass: "form-text text-muted" }, [
        _vm._v("Only if using 2FA.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }